module.exports = __webpack_public_path__ + "img/bottom_logo.4224984e.png";